import type { NestedFilter } from '@@partner:graphql/types'

import React, { useCallback, useState } from 'react'
import {
  getSearchableCustomerStatus,
  prepareCustomersFilter
} from '@@partner:helpers/customers'

import { Form, CheckPicker, Tag, Button, Input } from 'rsuite'
import LegacySearchIcon from '@rsuite/icons/legacy/Search'

import './CustomersFilter.scss'

export interface CustomersFiltersType {
  status: (string | number)[]
  phone: string
  first_name: string
  last_name: string
  receipt_email: string
}

export interface CustomersFilterProps {
  onFilterChanged: (filters: NestedFilter) => void
}

const AVAILABLE_CUSTOMER_STATUSES = getSearchableCustomerStatus()

const defaultFilter: CustomersFiltersType = {
  status: [],
  phone: '',
  first_name: '',
  last_name: '',
  receipt_email: ''
}

export default function CustomersFilter ({
  onFilterChanged
}: CustomersFilterProps) {
  const [ state, setState ] = useState<CustomersFiltersType>(defaultFilter)

  const handleFormSubmit = useCallback(() => {
    onFilterChanged(prepareCustomersFilter(state))
  }, [ onFilterChanged, state ])

  const makeFieldChangeHandler = useCallback(
    (name: string) => (e: any) => {
      setState((state) => ({
        ...state,
        [name]: e
      }))
    },
    []
  )

  const handleCustomerStatusChange = useCallback(
    (status: (string | number)[] = []) => {
      setState((state) => ({
        ...state,
        status
      }))
    },
    []
  )

  return (
    <Form
      formValue={state}
      className="CustomersFilter"
      onSubmit={handleFormSubmit}
    >
      <div className="CustomersFilter__Filters">
        <div className="CustomersFilter__Filters__Row">
          <Form.Group>
            <Input
              value={state.first_name}
              placeholder="Имя"
              onChange={makeFieldChangeHandler('first_name')}
              size="sm"
            />
          </Form.Group>
          <Form.Group>
            <Input
              value={state.last_name}
              placeholder="Фамилия"
              onChange={makeFieldChangeHandler('last_name')}
              size="sm"
            />
          </Form.Group>
        </div>
        <div className="CustomersFilter__Filters__Row">
          <Form.Group>
            <Input
              value={state.phone}
              placeholder="Телефон (78005552211)"
              onChange={makeFieldChangeHandler('phone')}
              size="sm"
            />
          </Form.Group>
          <Form.Group>
            <Input
              value={state.receipt_email}
              placeholder="Email"
              onChange={makeFieldChangeHandler('receipt_email')}
              size="sm"
            />
          </Form.Group>
        </div>
        <div className="CustomersFilter__Filters__Row">
          <CheckPicker
            value={state.status}
            data={AVAILABLE_CUSTOMER_STATUSES}
            searchable={false}
            placeholder="Статус"
            valueKey="value"
            labelKey="label"
            size="sm"
            style={{ maxWidth: 260 }}
            renderMenuItem={(label, item: any) => (
              <Tag key={item?.value} color={item?.color}>
                {label}
              </Tag>
            )}
            onChange={handleCustomerStatusChange}
          />
        </div>
      </div>
      <div className="CustomersFilter__Controls">
        <Button type="submit" size="lg" color="green" appearance="primary">
          <LegacySearchIcon /> Поиск
        </Button>
      </div>
    </Form>
  )
}
